<template>
    <base-dialog :value="dialog" :width="420" :title="dialogTitle" @input="onInput" @close="hide">
        <tutorial-list ref="list" :tutorials="tutorials" :selected="selected" @select="selected = $event"
            @back="selected = null" />
    </base-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BaseDialog from "@/components/common/BaseDialog";
import TutorialList from "@/components/common/TutorialList";
import { tutorialsFrom, localizedField } from "@/utils/Tutorials";

export default {
    name: "TutorialsDialog",
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    components: { BaseDialog, TutorialList },
    data() {
        return {
            dialog: false,
            selected: null,
        }
    },
    computed: {
        ...mapState({ tutorialsConfig: 'tutorials' }),
        dialogTitle(vm = this) {
            if (!vm.selected) return vm.$t('common.tutorials')
            return localizedField(vm.selected, 'title', vm.$i18n.locale) || ''
        },
        screen(vm = this) {
            return (vm.$route.name || '').split('.')[1] || ''
        },
        tutorials(vm = this) {
            return tutorialsFrom(vm.tutorialsConfig, { screen: vm.screen, accountType: vm.accountType })
        },
    },
    async mounted() {
        const vm = this;
        await vm.fetchTutorials()
    },
    methods: {
        ...mapActions(['fetchTutorials']),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.$refs.list?.pause()
            vm.dialog = false
            vm.selected = null
        },
        onInput(val) {
            if (!val) this.hide()
        },
    },
}
</script>
